<main class="recovery-page">
  <section class="brand-panel" aria-label="DeskPlus One">
    <a class="brand" routerLink="/login">
      <span class="brand-mark" aria-hidden="true">D+</span>
      <span>DeskPlus One</span>
    </a>

    <div class="brand-copy">
      <p class="eyebrow">ACCESO SEGURO</p>
      <h1>Recupera tu acceso.</h1>
      <p>
        Te ayudamos a volver a tu espacio de trabajo de forma segura,
        sin exponer informacion de tu cuenta.
      </p>
    </div>

    <p class="brand-footer">NIOTECH SOLUTIONS</p>
  </section>

  <section class="form-panel">
    <div class="form-shell">
      @if (!submitted()) {
        <header class="form-heading">
          <p class="eyebrow">RECUPERAR CONTRASENA</p>
          <h2>Volvamos a ponerte en marcha</h2>
          <p>
            Escribe el correo asociado a tu cuenta. Si podemos procesar
            la solicitud, recibiras un enlace seguro.
          </p>
        </header>

        @if (errorMessage()) {
          <div class="notice notice--error" role="alert">
            <span class="notice-mark" aria-hidden="true">!</span>
            <span>{{ errorMessage() }}</span>
          </div>
        }

        <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
          <div class="field">
            <label for="email">Correo electronico</label>
            <input
              id="email"
              type="email"
              formControlName="email"
              autocomplete="email"
              placeholder="nombre@empresa.com"
            />

            @if (form.controls.email.touched && form.controls.email.invalid) {
              <p class="field-error">Escribe un correo electronico valido.</p>
            }
          </div>

          <button class="primary-action" type="submit" [disabled]="loading()">
            @if (loading()) {
              <span class="spinner" aria-hidden="true"></span>
              Procesando...
            } @else {
              Enviar enlace seguro
              <span aria-hidden="true">&rarr;</span>
            }
          </button>
        </form>
      } @else {
        <header class="form-heading">
          <p class="eyebrow">REVISA TU CORREO</p>
          <h2>Solicitud recibida</h2>
          <p>
            Si existe una cuenta que puede recuperar acceso con ese correo,
            enviaremos las instrucciones correspondientes.
          </p>
        </header>

        <div class="notice notice--success" role="status">
          <span class="notice-mark" aria-hidden="true">&#10003;</span>
          <span>
            Revisa tu bandeja de entrada y tambien la carpeta de correo no deseado.
          </span>
        </div>
      }

      <a class="back-link" routerLink="/login">
        <span aria-hidden="true">&larr;</span>
        Volver a iniciar sesion
      </a>
    </div>
  </section>
</main>